export function activityLabel(type: "INTERVIEW" | "TRAINING", quantity: number) {
  const interview = quantity === 1 ? "Interview" : "Interviews";
  const training = quantity === 1 ? "Training" : "Trainings";
  return type === "INTERVIEW" ? interview : training;
}

export function monthlyActivityLabel(interviews: number, trainings: number) {
  return `${interviews} ${activityLabel("INTERVIEW", interviews)} • ${trainings} ${activityLabel("TRAINING", trainings)}`;
}
